export enum DiscoveryMeta {
  MODEL = "discovery",
  PK = "discovery_id",
}
